module.exports = __webpack_public_path__ + "img/title3_5.2d351961.png";